import apibase from './BaseAPI';

const save = async (property) => {
    const url = `/master/properties/draft/save`;
    try {
        const result = await apibase.post(url, property);
        return result.data;
    } catch (err) {
        throw err;
    }
};
const id = async (id) => {
    const url = `/master/properties/draft/${id}`;
    try {
        const result = await apibase.get(url);
        return result.data;
    } catch (err) {
        throw err;
    }
};


const search = async (agentId, val, status, paging) => {
    const params ={
        agentId: agentId,
        search: val,
        status: status,
        paging: paging
    };
    const url = '/master/properties/draft/searchAgent';
    try {
        const result = await apibase.post(url, params);
        return result.data;
    } catch (err) {
        throw err;
    }
};

export default {
    id: id,
    save: save,
    search: search,
};